namespace GeniuzPOS.Administration {
    export enum PsParaGenTypePrintQueueFg {
        PrintQueueFg0 = 0,
        PrintQueueFg1 = 1
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypePrintQueueFg, 'GeniuzPOS.Administration.PsParaGenTypePrintQueueFg', 'Administration.PsParaGenTypePrintQueueFg');
}
